<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center">
    <button (click)="goBack()" class="btn btn-primary"><fa-icon [icon]="faCircleArrowLeft"></fa-icon></button>
    <h1 class="fs-2 fw-light mb-0">Manage Rates</h1>
    <button (click)="goHome()" class="btn btn-info"><fa-icon [icon]="faHomeAlt"></fa-icon></button>
  </div>

  @if (errorMessage) {
    <div class="alert alert-danger mt-3">{{errorMessage}}</div>
  }

  @if (mode == 'list') {
    <div class="d-flex justify-content-end my-3">
      <button (click)="startCreate()" class="btn btn-primary">New Rate <fa-icon [icon]="faPlusCircle"></fa-icon></button>
    </div>

    @if (loading) {
      <div class="text-center my-4">
        <span class="spinner-border"></span>
      </div>
    } @else if (sortedRates.length == 0) {
      <div class="alert alert-info">No rates found for this property.</div>
    } @else {
      <table class="table table-striped table-bordered">
        <thead>
          <th scope="col">Entitlement</th>
          <th scope="col">Period</th>
          <th scope="col">Amount</th>
          <th scope="col">Option(s)</th>
        </thead>
        <tbody>
          @for (rate of sortedRates; track rate) {
            <tr>
              <td>{{rate.unit_entitlement}}</td>
              <td>{{rate.start_period | date:'MMM-d-y':'UTC'}} &rarr; {{rate.end_period | date:'MMM-d-y':'UTC'}}</td>
              <td>{{rate.amount | currency}}</td>
              <td>
                <button (click)="viewRate(rate)" class="btn btn-primary btn-sm m-1">View</button>
                <button (click)="startEdit(rate)" class="btn btn-secondary btn-sm m-1">Edit <fa-icon [icon]="faPenToSquare"></fa-icon></button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  }

  @if (mode == 'form') {
    <div class="card mt-3">
      <div class="card-body">
        <h2 class="fs-4 fw-light">{{editingRate ? 'Edit Rate' : 'New Rate'}}</h2>
        <form [formGroup]="rateForm">
          <div class="form-group my-4">
            <label class="form-label">Entitlement</label>
            <input class="form-control" type="text" formControlName="unit_entitlement" [ngClass]="{ 'is-invalid': f.unit_entitlement.touched && f.unit_entitlement.errors }"/>
          </div>
          <div class="form-group my-4">
            <label class="form-label">Start Date</label>
            <input class="form-control" type="date" formControlName="start_period" [ngClass]="{ 'is-invalid': f.start_period.touched && f.start_period.errors }"/>
          </div>
          <div class="form-group my-4">
            <label class="form-label">End Date</label>
            <input class="form-control" type="date" formControlName="end_period" [ngClass]="{ 'is-invalid': f.end_period.touched && f.end_period.errors }"/>
          </div>
          <div class="form-group my-4">
            <label class="form-label">Amount</label>
            <input class="form-control" type="text" formControlName="amount" [ngClass]="{ 'is-invalid': f.amount.touched && f.amount.errors }"/>
          </div>
          <div class="d-flex justify-content-between">
            <button type="button" (click)="cancelForm()" class="btn btn-danger">Cancel <fa-icon [icon]="faTimes"></fa-icon></button>
            <button [disabled]="saving" type="button" (click)="saveRate()" class="btn btn-primary">
              {{editingRate ? 'Update Rate' : 'Create Rate'}} @if (!saving) {
                <fa-icon [icon]="faCheck"></fa-icon>
              }
              @if (saving) {
                <span class="spinner-border spinner-border-sm mr-1"></span>
              }
            </button>
          </div>
        </form>
      </div>
    </div>
  }

  @if (mode == 'view' && selectedRate) {
    <div class="card mt-3">
      <div class="card-body">
        <h2 class="fs-4 fw-light">Rate Details</h2>
        <div class="form-group my-3">
          <label class="form-label fw-bold">Entitlement</label>
          <div>{{selectedRate.unit_entitlement}}</div>
        </div>
        <div class="form-group my-3">
          <label class="form-label fw-bold">Period</label>
          <div>{{selectedRate.start_period | date:'MMM-d-y':'UTC'}} &rarr; {{selectedRate.end_period | date:'MMM-d-y':'UTC'}}</div>
        </div>
        <div class="form-group my-3">
          <label class="form-label fw-bold">Amount</label>
          <div>{{selectedRate.amount | currency}}</div>
        </div>
        <div class="d-flex justify-content-between">
          <button (click)="closeView()" class="btn btn-secondary">Close</button>
          <button (click)="startEdit(selectedRate)" class="btn btn-primary">Edit <fa-icon [icon]="faPenToSquare"></fa-icon></button>
        </div>
      </div>
    </div>
  }
</div>
